import { introduction } from './introduction';
import { planning } from "./planning";
import { bia } from "./bia";
import { riskAnalysis } from "./risk-analysis";
import { recoveryStrategies } from "./recovery-strategies";
import { testing } from "./testing";
import { maturity } from "./maturity";

export interface DocData {
  /** i18n-Key für den Card-Titel */
  titleKey: string;
  /** i18n-Key für die Kurzbeschreibung */
  descriptionKey: string;
  /** Router-Segment, z.B. "planning" */
  route: string;
  /** SVG als String */
  iconSvg: string;
  /** Optional: Key für Tooltip-Kurztext */
  tooltipShortKey?: string;
  /** Optional: Key für den Link-Segment im Tooltip */
  tooltipLinkKey?: string;
}

// re-export aller Einträge

export const docs: DocData[] = [
  introduction,
  planning,
  bia,
  riskAnalysis,
  recoveryStrategies,
  testing,
  maturity,
];
